import { useEffect, useState, useRef, useCallback, Dispatch, SetStateAction } from "react";
import Webcam from "react-webcam";
import Modal from "../Modal";
import LoadingScreen from "../LoadingScreen";
import { checkCameraPermission } from "../../utils/utils";
import { videoConstraints } from "../../utils/constants";


function CameraPermission({ setShowDrawer, config,loader }: { setShowDrawer?: Dispatch<SetStateAction<boolean>>; config?: any,loader?:string }) {
	const [showDeniedModal, setShowDeniedModal] = useState({
		disabled: false,
		message: "",
	});
	const [loading, setLoading] = useState(true);
	const webcamRef = useRef(null);

	const handleCameraPermission = useCallback(async () => {
		const permission = await checkCameraPermission();
		setShowDeniedModal(permission);
		setLoading(false);
	}, []);

	useEffect(() => {
		handleCameraPermission();
	}, []);

	if (loading) {
		return <LoadingScreen url={loader} loaderType="black" />
	}

	if (showDeniedModal?.disabled) {
		return <Modal config={config} message={showDeniedModal?.message} />;
	}
	return (
		<Webcam
			audio={false}
			ref={webcamRef}
			screenshotQuality={1}
			videoConstraints={videoConstraints}
			mirrored
			onUserMedia={() => setShowDrawer?.(true)}
			screenshotFormat="image/jpeg"
			style={{
				position: "relative",
				top: 0,
				bottom: 0,
				zIndex: 0,
				width: "100%",
				height: "100%",
				objectFit: "cover",
			}}
		/>
	);
}

export default CameraPermission;
